import React from 'react';
import { LoaderSVG, LoaderUse } from './Loader.style';

/* /!\ If you change something here, change it in the public/index.html too */
export const Loader: React.FunctionComponent = () => {
  return (
    <LoaderSVG viewBox="-2000 -1000 4000 2000">
      <linearGradient id="lc-loader-gradient">
        <stop offset="0%" stopColor="#0bc1c1" stopOpacity="0.3"/>
        <stop offset="50%" stopColor="#0bc1c1" stopOpacity="0.7"/>
        <stop offset="100%" stopColor="#0bc1c1" stopOpacity="0.3"/>
      </linearGradient>
      <path id="lc-loader-infinite" d="M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z" />
      <LoaderUse stroke="url(#lc-loader-gradient)" href="#lc-loader-infinite" strokeDasharray="1570 5143" strokeDashoffset="6713px" />
    </LoaderSVG>
  );
};
